<template>
	<div id="Ypxx" style="margin-top:-20px;">

		<div class="g-right-middle width800">
			<div class="g-ypxx">

				<p>
					<span class="ypxx-left">作品名称</span>
					<span class="ypxx-right"><input v-model="movie_name" type="text" placeholder="请输入作品名称"></span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">出品方</span>
					<span class="ypxx-right"><input v-model="make" type="text" placeholder="请输入出品方单位">
					</span>

					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">筹备地点</span>
					<span class="ypxx-right">
						<input v-model="prepare" type="text" placeholder="请输入筹备地点">
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">开机时间</span>
					<span class="ypxx-right2" style="margin-left: 6px;">
						<col span="12">
						<el-date-picker class="input-data" v-model="start_time" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
						</el-date-picker>
						</col>
					</span>
					<!-- <input type="text" v-model="start_time"> -->
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">拍摄周期</span>
					<span class="ypxx-right"><input v-model="take_period" type="text" placeholder="请输入拍摄周期！例：28">
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">拍摄地点</span>
					<span class="ypxx-right">
						<RadioGroup v-model="take_place">
							<Radio label="1">北京</Radio>
							<Radio label="2">上海</Radio>
							<Radio label="3">横店</Radio>
							<Radio label="4">其他</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">影片类型</span>
					<span class="ypxx-right">
						<RadioGroup v-model="theme">
							<Radio label="1">院线电影</Radio>
							<Radio label="2">网络电影</Radio>
							<Radio label="3">数字电影</Radio>
							<Radio label="4">电视剧</Radio>
							<Radio label="5">网络剧</Radio>
							<Radio label="6">广告拍摄</Radio>
							<Radio label="7">MV拍摄</Radio>
							<Radio label="8">综艺节目</Radio>
							<Radio label="9">演出活动</Radio>
							<Radio label="10">其他</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">剧情简介</span>
					<span class="ypxx-right">
						<textarea v-model="synopsis" class="g-wd-txt" placeholder="限300字以内"></textarea>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">影片封面</span>

					<span class="ypxx-right">
						<div class="imgfm" style="float: left;">
							<img :src="imgsrc" width="250" height="350" :onerror="errorImg">
						</div>
						<div class="float-right">
							<div class="line" style="">
								<div class="cropper-content" style="">
									<div class="cropper">
										<vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true"
										 :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original"
										 :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
										 :fixedBox="option.fixedBox" @realTime="realTime" @imgLoad="imgLoad"></vueCropper>
									</div>
								</div>
							</div>
							<center>
								<div class="crop-btn">
									<label class="crop-select-btn" for="uploads">选择</label>
									<input type="file" id="uploads" :value="imgFile" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg"
									 @change="uploadImg($event, 1)">
									<input type="button" class="oper" value="+" title="放大" @click="changeScale(1)">
									<input type="button" class="oper" value="-" title="缩小" @click="changeScale(-1)">
									<label class="crop-select-btn" @click="finish('blob')">裁剪</label>

								</div>
							</center>
						</div>
						<div class="clearfix"></div>
					</span>
					<div class=" clearfix"></div>
				</p>
				<center><input @click="ypxx" type="submit" class="g-btn" value="下一步"></center>


			</div>


		</div>
	</div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'


	export default {
		data() {
			return {
				errorImg: 'this.src="' + require('../../../assets/mrimg.png') + '"', //未上传时显示默认图片
				crap: false,
				previews: {},
				option: {
					img: '',
					outputSize: 1, //剪切后的图片质量（0.1-1）
					full: false, //输出原图比例截图 props名full
					outputType: 'jpeg',
					canMove: true, //能否拖动图片
					original: false, //是否显示原始宽高
					canMoveBox: false, //能否拖动截图框
					autoCrop: true, //是否自动生成截图框
					autoCropWidth: 250,
					autoCropHeight: 350,
					fixedBox: true // 固定大小 禁止改变截图框大小
				},
				fileName: '', //本机文件地址
				imgFile: '',
				uploadImgRelaPath: '', //上传后的图片的地址（不带服务器域名）
				movie_name: '',
				make: '',
				prepare: '',
				take_place: '',
				start_time: '',
				take_period: '',
				theme: '',
				synopsis: '',
				picture: '',
				imgsrc: '',
				uid: '',
			}
		},
		methods: {
			changeScale(num) {
				// console.log('changeScale')
				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},

			finish(type) {
				// console.log('finish')
				let _this = this;
				// 输出 
				if (type === 'blob') {
					this.$refs.cropper.getCropBlob((data) => {
						let img = window.URL.createObjectURL(data)
						this.model = true;
						this.modelSrc = img;
						//将获取到的裁剪后图片信息转成base64格式
						var image = new Image();
						var vm = this
						var reader = new FileReader();
						reader.readAsDataURL(data);
						reader.onload = function(e) {
							vm.imgsrc = e.target.result //将base64信息赋值给需要显示图片的字段
						}
					})
				} else {
					this.$refs.cropper.getCropData((data) => {
						this.model = true;
						this.modelSrc = data;
					})
				}
			},
			// 实时预览函数 
			realTime(data) {
				// console.log('realTime')
				this.previews = data
			},
			//选择本地图片
			uploadImg(e, num) {
				var _this = this;
				var file = e.target.files[0]
				_this.fileName = file.name;
				if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
					alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
					return false
				}
				var reader = new FileReader();
				reader.onload = (e) => {
					let data;
					if (typeof e.target.result === 'object') {
						// 把Array Buffer转化为blob 如果是base64不需要 
						data = window.URL.createObjectURL(new Blob([e.target.result]))
					} else {
						data = e.target.result
					}
					if (num === 1) {
						_this.option.img = data
					} else if (num === 2) {
						_this.example2.img = data
					}
				}
				reader.readAsArrayBuffer(file);

			},
			imgLoad(msg) {
				// console.log('imgLoad')
			},

			ypxx(event) {
				var api = 'https://api.yopoo.cn/api/centre/createcrew'
				event.preventDefault();
				let formData = new FormData();
				formData.append('movie_name', this.movie_name);
				formData.append('make', this.make);
				formData.append('prepare', this.prepare);
				formData.append('take_place', this.take_place);
				formData.append('start_time', this.start_time);
				formData.append('take_period', this.take_period);
				formData.append('theme', this.theme);
				formData.append('synopsis', this.synopsis);
				formData.append('picture', this.imgsrc);
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				Axios.post(api, formData, config).then((res) => {
					if (res.data.code == '200') {
						this.uid = storage.set('newuid', res.data.uid) //用户填写影片信息返回的id值
						// console.log(res.data.uid)
						setTimeout(() => { //测试uid暂时取消跳转
							this.$message({ //提示发送验证码成功信息
								message: res.data.msg,
								type: 'success',
								center: true
							});
							this.$router.push({
								path: '/group_admin/edit/zcry',
							}) //登录后跳转页面
						}, 200);
					}
					if (res.data.code == '202') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'error',
							center: true
						});
					}
				}).catch((res) => {})
			},
		},
		mounted() {
			var uid = storage.get('uid')
			if (uid) {
				this.uid = uid
			}
		}
	}
</script>

<style scoped lang="less">
	.info {
		width: 720px;
		margin: 0 auto;

		.oper-dv {
			height: 20px;
			text-align: right;
			margin-right: 100px;

			a {
				font-weight: 500;

				&:last-child {
					margin-left: 30px;
				}
			}
		}

		.info-item {
			margin-top: 15px;

			label {
				display: inline-block;
				width: 100px;
				text-align: right;
			}

			.sel-img-dv {
				position: relative;

				.sel-file {
					position: absolute;
					width: 90px;
					height: 30px;
					opacity: 0;
					cursor: pointer;
					z-index: 2;
				}

				.sel-btn {
					position: absolute;
					cursor: pointer;
					z-index: 1;
				}
			}
		}
	}

	.cropper-content {
		// 		display: flex;
		// 		display: -webkit-flex;
		// 		justify-content: flex-end;
		// 		-webkit-justify-content: flex-end;

		.cropper {
			width: 250px;
			height: 350px;
		}

		.show-preview {
			flex: 1;
			-webkit-flex: 1;
			display: flex;
			display: -webkit-flex;
			justify-content: center;
			-webkit-justify-content: center;

			.preview {
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid #cccccc;
				background: #cccccc;
				margin-left: 40px;
			}
		}
	}

	.cropper-content .show-preview .preview {
		margin-left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/group_admin/edit/G_Ypxx.vue